import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ApiDocumentationPortal from "screens/App/CRM/CanUsers/Vendor/ApiCredential/apiCredentialComponents/ApiTestingScreen";
import APICredentialScreen from "screens/App/CRM/CanUsers/Vendor/ApiCredential/APICredentialScreen";


import NotFoundScreen from "screens/NotFoundScreen";

const IntegrationRouter = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="api-credential" replace />} />
      <Route path="api-credential" element={<APICredentialScreen />} />
      <Route path="api-documentations" element={<ApiDocumentationPortal />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default IntegrationRouter;
